// Learn TypeScript:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/typescript.html
// Learn Attribute:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/reference/attributes.html
// Learn life-cycle callbacks:
//  - https://docs.cocos.com/creator/2.4/manual/en/scripting/life-cycle-callbacks.html

import BasePopUpLayer from "../../../../engines/components/BasePopUpLayer";
import BaseStatePlusSprite from "../../../../engines/components/state/BaseStatePlusSprite";
import O1HD from "../../../../engines/gameEngine";

const {ccclass, property} = cc._decorator;

@ccclass
export default class HitRobGameHint extends BasePopUpLayer {

    @property(BaseStatePlusSprite)
    sprHint: BaseStatePlusSprite = null;

    // LIFE-CYCLE CALLBACKS:

    // onLoad () {}

    start () {
        let lv = this._carryData.level;
        this.sprHint.setFill(lv);
    }

    onClickClose() {
        O1HD.getManagers().soundMgr.playSound("anNiu");
        this.destroyNode();
    }
    // update (dt) {}
}
